<div class="main-container">
    <div class="qb-header">
        <div class="module-heading">
            Coupons
        </div>
    </div>
    <div class="card-cont">
        <div class="b-text">Drive customer action with targeted coupon pools.</div>
        <div class="c-text">
            Coupon pools allow you to group and manage discount codes efficiently. Customize and distribute coupons to incentivize purchases, attract new users, and boost customer retention. 
        </div>
    </div>
    <div class="main-white-panel custom-panel m-h-400">
        <div class="d-flex align-items-center col-sm-12 mb-2">
            <div class="col-sm-4 me-1">
                <div class="search-container ">
                    <input
                        #search
                        type="text"
                        placeholder="Search by Coupon Code"
                        (input)="listSearch = listSearch.toUpperCase();onKeySearch(search.value)"
                        [(ngModel)]="listSearch"
                    />
                    <span class="material-icons icons-primary" *ngIf="search.value.length==0"> search </span>
                    <span class="material-icons icons-primary cursor-pointer" *ngIf="search.value.length>0" (click)="clearSearch()">
                        close
                    </span>
                </div>
            </div>
            <div *ngIf="!this.isDataLoading"
                class="filterButton button-hover-effect me-2"
                (click)="openFiltersDiv()"
                data-button-name="Filter"
                style="display: flex" style="cursor: pointer" [matTooltipShowDelay]="200" [matTooltip]="'COMMON_PAGE.FILTERS' | i18nTranslate">
                <svg width="17" height="20" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 10C16.1348 10 20.5 7.98528 20.5 5.5C20.5 3.01472 16.1348 1 10.75 1C5.36522 1 1 3.01472 1 5.5C1 7.98528 5.36522 10 10.75 10Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1 5.5C1.00253 10.0155 4.10614 13.938 8.5 14.979V21.25C8.5 22.4926 9.50736 23.5 10.75 23.5C11.9926 23.5 13 22.4926 13 21.25V14.979C17.3939 13.938 20.4975 10.0155 20.5 5.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="active-filters" *ngIf="hasFilter()">
                <div *ngIf="filters['couponPool']?.length>0" class="filters-container">
                  CouponPool filter
                  <div *ngFor="let id of filters['couponPool']" class="each-filter">
                    <div class="overflowable-text" [matTooltip]="getCouponPoolName(id)" [matTooltipShowDelay]="200">
                      {{getCouponPoolName(id)}}
                    </div>
                    <div *ngIf="!this.isDataLoading" class="material-icons icons-primary filter-clear" (click)="removeFilter('couponPool',id)">clear</div>
                  </div>
                </div>
                <div *ngIf="filters['isRedeemed'] || filters['isRedeemed']==false" class="filters-container">
                    <div class="each-filter">
                        <div class="overflowable-text" [matTooltip]="'Redeemed'" [matTooltipShowDelay]="200" *ngIf="filters['isRedeemed']">
                          Redeemed
                        </div>
                        <div class="overflowable-text" [matTooltip]="'Not Redeemed'" [matTooltipShowDelay]="200" *ngIf="filters['isRedeemed'] == false">
                            Not Redeemed
                        </div>
                        <div *ngIf="!this.isDataLoading" class="material-icons icons-primary filter-clear" (click)="removeFilter('isRedeemed')">clear</div>
                    </div>
                </div>
            </div>
            <div class="d-flex margin-left-auto">
                <button class="primary-button secondary-button button-hover-effect me-3" (click)="openExportDialog()" *ngIf="!isDataLoading && couponPoolList.length > 0 && (!couponPoolBeingPopulatedName && !couponPoolBeingExportedName)" 
                    [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                    [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
                    [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
                    Export Coupon Pool
                </button>
                <button class="primary-button button-hover-effect" (click)="openCreateDialog('create')" *ngIf="!isDataLoading && (!couponPoolBeingPopulatedName && !couponPoolBeingExportedName)" 
                [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
                [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
                    Create Coupon Pool
                </button>
            </div>
        </div>

        <div class="listing-container">
            <div class="list-column-header-row">
                <div class="col-header wide-column-width">
                    Coupon Code
                </div>
                <div class="col-header">
                    Pool Name
                </div>
                <div class="col-header">
                    Created At
                </div>
                <div class="col-header">
                    Status
                </div>
                <div class="col-header">
                    Actions
                </div>
            </div>
            <div class="main-list">
                <div class="list-loader-container" *ngIf="isDataLoading">
                    <app-qubriux-loading  [size]="65" [loadingText]="'Fetching your coupons...'"></app-qubriux-loading>
                </div>
                <div *ngIf="!isDataLoading && couponList.length == 0" class="empty-list-indicator">
                    No Coupon found
                </div>
                <div *ngIf="!isDataLoading && couponList.length > 0">
                    <div *ngFor="let coupon of couponList" class="list-item-row">
                        <div class="list-item wide-column-width overflow-hidden">
                            <div class="ellipsis-text"><span [matTooltip]="coupon.code" [matTooltipShowDelay]="200">{{coupon.code}}</span></div>
                        </div>
                        <div class="list-item overflow-hidden">
                            <div class="ellipsis-text"><span [matTooltip]="coupon.couponPoolName" [matTooltipShowDelay]="200">{{coupon.couponPoolName}}</span></div>
                        </div>
                        <div class="list-item">
                            <div>{{ getDateInTimeZone(coupon.createdAt, 'date') }} | {{ getDateInTimeZone(coupon.createdAt, 'time')}}</div>
                        </div>
                        <div class="list-item">
                            <div *ngIf="coupon.isRedeemed" class="redeemed-style">Redeemed</div>
                            <div *ngIf="!coupon.isRedeemed && coupon.status == 'ACTIVE'" class="active-style">{{coupon.status}}</div>
                            <div *ngIf="!coupon.isRedeemed && coupon.status == 'EXPIRED'" class="expired-style">{{coupon.status}}</div>
                            
                        </div>
                        <div class="list-item action-icon-container">
                            <button 
                            class="qb-disable-button-container"
                            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Edit this coupon Configuration')"
                            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" (click)="openCreateDialog('editCoupon',coupon)">
                                <span class="material-symbols-outlined sp-icon-1" >
                                    edit
                                </span>
                            </button>

                            <button 
                            class="qb-disable-button-container"
                            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Edit Pool Configuration')"
                            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" (click)="openCreateDialog('editPool',coupon)">
                                <span  class="material-symbols-outlined sp-icon-1" >
                                    app_registration
                                </span>
                            </button>

                            <button 
                            class="qb-disable-button-container"
                            *ngIf="coupon.couponOfferId || coupon.couponGiftCodeId"
                            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Coupon has configuration different from the pool')" [matTooltipShowDelay]="200"
                            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
                                <span class="material-symbols-outlined orange-style asterisk-style" >
                                    asterisk
                                </span>
                            </button>

                            <!-- <span [matTooltip]="'Clone badge Configuration'" class="material-symbols-outlined sp-icon-1" (click)="openCreateDialog('clone',badge.id)">
                                copy_all
                            </span>
                            <span [matTooltip]="'Delete badge Configuration'" class="material-symbols-outlined sp-icon-1 red-text" (click)=deleteBadge(badge.id)>
                                delete
                            </span> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="lv-options-22">
                <div class="d-flex align-items-center">
                    <div *ngIf="couponPoolBeingPopulatedName" class="info-text-container orange-style me-3"><span class="qb-i-div orange-style">i</span> {{couponPoolBeingPopulatedName}} is populating. Refresh to update.</div>
                    <div *ngIf="couponPoolBeingExportedName" class="info-text-container orange-style me-3"><span class="qb-i-div orange-style">i</span> {{couponPoolBeingExportedName}} is exporting. Download will start soon.</div>
                    <div *ngIf="!isDataLoading" class="info-text-container cursor-pointer" matTooltip="Refresh List" (click)="refreshData()">
                        <span class="material-symbols-outlined refresh-icon">
                            sync
                        </span>
                    </div>
                </div>
                
                <mat-paginator *ngIf="couponList?.length > 0 && !isDataLoading" class="margin-left-auto"
                    #paginator 
                    [pageIndex]="paginationConfig.pageIndex"
                    [length]="paginationConfig.total"
                    [pageSize]="paginationConfig.pageSize"
                    [pageSizeOptions]="[5, 10, 25, 100]"
                    (page)="refreshPaginatedData($event)"
                >
                </mat-paginator>
            </div>
        </div>
    </div>

    <div *ngIf="showFiltersDiv">
        <div class="overlay"></div>
        <div class="filter-actions">
            <div class="titleDiv">
                <div style="display: flex; justify-content: space-between;align-items: center;">
                <div class="title">{{'CAMPAIGN_PAGE.FILTERS_NOR' | i18nTranslate}}</div>
                <div *ngIf="showClearAll" class="clear-all-button button-hover-effect" (click)="clear()">
                    {{'CAMPAIGN_PAGE.CLEAR_ALL_CAPS' | i18nTranslate}}
                </div>
                </div>
                <div (click)="closeFiltersDiv()" class="material-icons icons-primary close-style">
                    clear
                </div>
            </div>
            <div class="filter-container-journey">
                <div class="filter">
                    <div>
                        <p><strong style="font-size: 13px">Coupon Pool</strong></p>
                        <div>
                            <div class="campaignlistRectangle2" *ngIf="this.couponPoolList.length>4">
                                <div class="campaignlistsearchBar">
                                <input
                                    #search1
                                    type="text"
                                    placeholder="Search by Coupon pool name"
                                    [(ngModel)]="couponPoolFilterSearch"
                                />
                                <span class="material-icons icons-primary" style="font-size: 19px;" *ngIf="search1.value.length==0"> search </span>
                                <span class="material-icons-outlined icons-primary cursor-pointer" style="font-size: 19px;"  *ngIf="search1.value.length>0" (click)="couponPoolFilterSearch='';">
                                    close
                                </span>
                                </div>
                            </div>
                            <div class="height-150">
                                <p *ngFor="let couponPool of getFilteredCouponPools()" style="word-break: break-all">
                                <mat-checkbox
                                    color="primary"
                                    [checked]="filters['couponPool'].indexOf(couponPool.id) != -1"
                                    name="{{ couponPool.name }}"
                                    (change)="addSegmentFilter(couponPool.id,'couponPool')"
                                    >{{ couponPool.name }}</mat-checkbox
                                >
                                </p>
                                <p *ngIf="getFilteredCouponPools().length == 0" class="no-data-div">
                                    {{'CAMPAIGN_PAGE.NO_DATA_AVAILABLE' | i18nTranslate}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter">
                    <div>
                      <p><strong style="font-size: 13px">Redemption</strong></p>
                      <p class="inline-blocker">
                        <mat-checkbox
                          [checked]="filters['isRedeemed']"
                          (change)="addRedemptionFilter($event,'isRedeemed')"
                          color="primary"
                        >Redeemed</mat-checkbox>
                      </p>
                      <p class="inline-blocker">
                        <mat-checkbox
                          [checked]="filters['isRedeemed'] == false"
                          (change)="addRedemptionFilter($event,'notRedeemed')"
                          color="primary"
                        >Not Redeemed</mat-checkbox>
                      </p>
                    </div>
                </div>
            </div>
          <div class="bottom-button-container">
              <button class="secondary-button-border" (click)="closeFiltersDiv()">
                {{'CAMPAIGN_PAGE.CANCEL' | i18nTranslate}}
              </button>
              <button class="apply primary-button" (click)="applyFilter()">
                {{'CAMPAIGN_PAGE.APPLY' | i18nTranslate}}
              </button>
          </div>
        </div>
    </div>
    
</div>
